import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "clock",
  "use": "clock-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"clock\">\n<path d=\"M12,23C5.9,23,1,18.1,1,12S5.9,1,12,1s11,4.9,11,11S18.1,23,12,23z M12,3c-5,0-9,4-9,9c0,5,4,9,9,9c5,0,9-4,9-9\n\tC21,7,17,3,12,3z\" />\n<path d=\"M16,15c-0.2,0-0.3,0-0.4-0.1l-4-2C11.2,12.7,11,12.4,11,12V6c0-0.6,0.4-1,1-1s1,0.4,1,1v5.4l3.4,1.7\n\tc0.5,0.2,0.7,0.8,0.4,1.3C16.7,14.8,16.4,15,16,15z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol